import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/footer/footer";
import { api, s3Url } from "../service/api.service";

const getAssetUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  return `${s3Url}${path}`;
};

const AudioAlbum = () => {
  const [audioAlbums, setAudioAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAlbums = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get("/admin/album/allAlbumlist");
        const data = response?.data || response;
        const albums = data?.data || data || [];
        setAudioAlbums(Array.isArray(albums) ? albums : []);
      } catch (err) {
        console.error("Audio albums API error:", err);
        setError("Unable to load audio playlists. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchAlbums();
  }, []);

  return (
    <div className="bg-[#FFF5F3] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-24">
        <div className="text-center mb-16">
          <h1
            className="text-5xl font-semibold mb-4"
            style={{ fontFamily: "Philosopher, sans-serif" }}
          >
            Audio Playlists
          </h1>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Browse playlists from the audio API and open any playlist to view
            the track list.
          </p>
        </div>

        {loading ? (
          <div className="text-center text-lg text-gray-600">
            Loading playlists...
          </div>
        ) : error ? (
          <div className="text-center text-red-600">{error}</div>
        ) : audioAlbums.length === 0 ? (
          <div className="text-center text-gray-600">
            No playlists available.
          </div>
        ) : (
          <div className="grid gap-8 lg:grid-cols-2">
            {audioAlbums.map((album) => (
              <Link
                key={album._id}
                to={`/audio-album/${album._id}`}
                className="rounded-[32px] overflow-hidden bg-white shadow-boxshadow2 border border-gray-200 hover:shadow-xl transition-shadow"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
                  <img
                    src={getAssetUrl(album.imageURL)}
                    alt={album.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <p className="text-xs uppercase tracking-[0.2em] text-white/80">
                      Playlist
                    </p>
                    <h2 className="text-2xl font-semibold">{album.name}</h2>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AudioAlbum;
